/* eslint-disable max-len */
import React from 'react';

const DndIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" {...props}>
    <g fillRule="evenodd">
      <g>
        <g>
          <g>
            <g>
              <path
                d="M5.37 7.083c-.684-.025-1.22-.596-1.203-1.28.017-.685.58-1.228 1.265-1.22.684.009 1.234.566 1.235 1.25-.014.704-.594 1.263-1.297 1.25zM5.37 2.5c-.684-.026-1.22-.597-1.203-1.28.017-.685.58-1.228 1.265-1.22.684.009 1.234.566 1.235 1.25-.014.703-.594 1.263-1.297 1.25zM5.463 9.167c.684.025 1.22.596 1.203 1.28-.017.685-.58 1.228-1.265 1.22-.684-.009-1.234-.566-1.234-1.25.014-.703.594-1.262 1.296-1.25zM1.203 7.083C.52 7.058-.017 6.487 0 5.803c.017-.685.581-1.228 1.265-1.22.685.009 1.235.566 1.235 1.25-.013.704-.594 1.263-1.297 1.25zM1.203 2.5C.52 2.474-.017 1.903 0 1.22.017.534.581-.009 1.265 0 1.95.01 2.5.566 2.5 1.25c-.013.703-.594 1.263-1.297 1.25zM1.297 9.167c.683.025 1.22.596 1.203 1.28-.017.685-.581 1.228-1.265 1.22C.55 11.658 0 11.1 0 10.417c.015-.703.594-1.262 1.297-1.25z"
                transform="translate(-99 -190) translate(99 176) translate(0 14) translate(6.667 4.167)"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default DndIcon;
